import { Link } from "react-router-dom";
import { LayoutDashboard, FileText, Users, LogOut, Wrench, Tags, Webhook } from "lucide-react";

const Sidebar = ({ onLogout }) => (
  <aside className="hidden md:flex flex-col w-64 bg-[#00341d] text-white">
    <div className="p-6">
      <img src="https://customer-assets.emergentagent.com/job_665c49ba-1471-4262-8719-d672e8150062/artifacts/l1uvt1c1_Logo_Framed_Green.png" alt="Land ClearCo" className="w-36" />
    </div>
    <nav className="flex-1 px-4 py-6 space-y-2">
      <Link to="/" className="sidebar-link active"><LayoutDashboard className="w-5 h-5" /><span>Dashboard</span></Link>
      <Link to="/quotes/new" className="sidebar-link"><FileText className="w-5 h-5" /><span>New Quote</span></Link>
      <Link to="/customers" className="sidebar-link" data-testid="nav-customers"><Users className="w-5 h-5" /><span>Customers</span></Link>
      <Link to="/equipment" className="sidebar-link" data-testid="nav-equipment"><Wrench className="w-5 h-5" /><span>Equipment Logs</span></Link>
      <Link to="/services" className="sidebar-link" data-testid="nav-services"><Tags className="w-5 h-5" /><span>Services &amp; Pricing</span></Link>
      <Link to="/webhooks" className="sidebar-link" data-testid="nav-webhooks"><Webhook className="w-5 h-5" /><span>Webhooks</span></Link>
    </nav>
    <div className="p-4 border-t border-white/10">
      <button onClick={onLogout} className="sidebar-link w-full text-white/60 hover:text-white" data-testid="logout-button">
        <LogOut className="w-5 h-5" /><span>Sign Out</span>
      </button>
    </div>
  </aside>
);

export default Sidebar;
